module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjEzLjkwOTMiIGhlaWdodD0iMTcuNTA3OCIgdmlld0JveD0iMCAwIDEzLjkwOTMgMTcuNTA3OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9Imljb24iIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxNy41MDc4VjBMMTMuOTA5MyA4Ljc1MzkxTDAgMTcuNTA3OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/icon-arrow.svg
// module id = 1260
// module chunks = 4 5